import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveAttributeName(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const attributeNameData = {
    doc_type: DocType.ATTRIBUTE_NAME,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    system_defined: util.toBoolean(data.system_defined)
  };
  return common.saveDoc(app, {
    source: data,
    doc: attributeNameData,
    user
  });
}

export function deleteAttributeName(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ATTRIBUTE_NAME
  });
}

export function fetchAttributeNameById(app, params) {
  const { id } = params;
  const docType = DocType.ATTRIBUTE_NAME;
  return common.getDoc(app, { id, docType });
}
